import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const HeadphonesIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M18.75 21.125a2.252 2.252 0 01-2.25-2.25v-6a2.252 2.252 0 012.25-2.25c.246 0 .497.019.75.057v-.807c-.012-4.123-3.377-7.488-7.502-7.5-4.122.012-7.486 3.377-7.498 7.502v.805c.253-.038.504-.057.75-.057a2.252 2.252 0 012.25 2.25v6a2.252 2.252 0 01-2.25 2.25A5.256 5.256 0 010 15.875a5.239 5.239 0 013-4.742V9.875c.014-4.949 4.051-8.986 8.998-9 4.95.014 8.988 4.051 9.002 8.998v1.26c1.831.869 3 2.704 3 4.742a5.256 5.256 0 01-5.25 5.25zm0-9a.75.75 0 00-.75.75v6c0 .414.336.75.75.75 2.068 0 3.75-1.682 3.75-3.75s-1.682-3.75-3.75-3.75zm-13.5 0c-2.068 0-3.75 1.682-3.75 3.75s1.682 3.75 3.75 3.75a.75.75 0 00.75-.75v-6a.75.75 0 00-.75-.75z" />
  </Icon>
);

export default HeadphonesIcon;
